export default __webpack_public_path__ + "apply119fc615.png";